import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Badge, Button, Spinner, Table } from 'flowbite-react';
import {
  HiCheck,
  HiExclamationCircle,
  HiOutlineInformationCircle,
  HiOutlineLocationMarker,
  HiOutlinePhone,
} from 'react-icons/hi';
import { ClientStatus, TimeAgo } from '../../../components';

interface IDeviceListTable {
  devices: any[];
  loading: boolean;
}

// Todo:
// son mesaj ve limit cihaz tipine göre gösterilecek
// - [ ] Son Mesaj
// - [ ] Limit

export const DeviceListTable: FC<IDeviceListTable> = ({ devices, loading }) => {
  return (
    <>
      {loading ? (
        <div className="text-center">
          <Spinner />
        </div>
      ) : (
        <Table striped hoverable>
          <Table.Head>
            <Table.HeadCell>ID</Table.HeadCell>
            <Table.HeadCell>Cihaz Adı</Table.HeadCell>
            <Table.HeadCell></Table.HeadCell>
            {/* <Table.HeadCell>Son Mesaj</Table.HeadCell> */}
            <Table.HeadCell>Bağlantı</Table.HeadCell>
            <Table.HeadCell>Gönderim</Table.HeadCell>
            {/* <Table.HeadCell>Limit</Table.HeadCell> */}
            <Table.HeadCell></Table.HeadCell>
          </Table.Head>
          <Table.Body>
            {devices.map((device: any) => {
              const {
                _id: id,
                name,
                number,
                clientStatus,
                ip,
                lastMessage,
                isMessageSent,
                dailyLimit,
                dailyTotalMessage,
              } = device;
              return (
                <Table.Row key={id}>
                  <Table.Cell className="whitespace-nowrap">{id}</Table.Cell>
                  <Table.Cell>{name}</Table.Cell>
                  <Table.Cell>
                    {number && (
                      <div className="flex items-center">
                        <HiOutlinePhone className="mr-2" /> {number}
                      </div>
                    )}
                    <div className="mt-2 flex items-center">
                      <HiOutlineLocationMarker className="mr-2" />
                      {ip}
                    </div>
                  </Table.Cell>
                  {/* <Table.Cell className="whitespace-nowrap">
                    {lastMessage && (
                      <div className="flex items-center">
                        <TimeAgo date={lastMessage?.createdAt} />
                        {lastMessage.isAnswered
                          ? ' / Cevapladı'
                          : ' / Gönderildi'}
                      </div>
                    )}
                  </Table.Cell> */}
                  <Table.Cell>
                    <div className="flex items-center">
                      {ClientStatus(clientStatus)}
                    </div>
                  </Table.Cell>
                  <Table.Cell>
                    <div className="flex items-center">
                      <Badge
                        color={isMessageSent ? 'success' : 'warning'}
                        icon={isMessageSent ? HiCheck : HiExclamationCircle}
                      >
                        <p className="uppercase">
                          {isMessageSent ? 'Aktif' : 'Pasif'}
                        </p>
                      </Badge>
                    </div>
                  </Table.Cell>
                  {/* <Table.Cell>
                    {dailyTotalMessage} / {dailyLimit}
                  </Table.Cell> */}
                  <Table.Cell>
                    <div className="flex items-center">
                      <Button
                        size="sm"
                        color="light"
                        as={Link}
                        to={`/device/${id}`}
                        title="Cihaz Detay"
                      >
                        <HiOutlineInformationCircle />
                      </Button>
                    </div>
                  </Table.Cell>
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      )}
    </>
  );
};
